import React from 'react';
import { Card, Form, InputNumber, Button, Space, Row, Col, message } from 'antd';
import { SaveOutlined, ReloadOutlined } from '@ant-design/icons';
import { getCrawlConfig, updateCrawlConfig } from '../../utils/api';
const CrawlConfig = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const defaultValues = {
    videoDuration: 60,
    videoCount: 10,
    publishDateRange: 180,
    autoCrawl: false,
    crawlInterval: 24,
    enabledPlatforms: ['youtube'],
  };

  const loadConfig = async () => {
    try {
      setLoading(true);
      const data = await getCrawlConfig();
      form.setFieldsValue(data);
    } catch (e) {
      message.error('加载配置失败');
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => { loadConfig(); }, []);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      await updateCrawlConfig(values);
      message.success('保存成功');
    } catch (e) {
      message.error('保存失败');
    } finally {
      setLoading(false);
    }
  };

  const onReset = () => form.resetFields();

  return (
    <div>

      <Card title="过滤规则配置" loading={loading}>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          onReset={onReset}
          initialValues={defaultValues}
        >
          <Row gutter={24}>
            <Col xs={24} md={12}>
              <Form.Item label="视频时长过滤" name="videoDuration" extra="默认 60 秒">
                <InputNumber min={0} style={{ width: '100%' }} addonAfter="秒" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item label="视频数量上限" name="videoCount" extra="默认 10 条">
                <InputNumber min={1} max={100} style={{ width: '100%' }} addonAfter="条" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={24} md={12}>
              <Form.Item label="发布时间范围" name="publishDateRange" extra="默认 180 天">
                <InputNumber min={1} max={365} style={{ width: '100%' }} addonAfter="天" />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item style={{ textAlign: 'right' }}>
            <Space>
              <Button htmlType="reset" icon={<ReloadOutlined />}>重置</Button>
              <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>保存</Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default CrawlConfig;